var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { attrs: { tabindex: "-1" } }, [
      _vm._v(_vm._s(_vm.$t("Title_Attachments")))
    ]),
    _vm._v(" "),
    _vm.report &&
    _vm.report.orgYearlyReportAttachments &&
    _vm.report.orgYearlyReportAttachments.attachmentsCollection
      ? _c(
          "div",
          { staticClass: "mt-4" },
          [
            _c("plain-text-control", { attrs: { title: "Attachments.Title" } }),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "table tablerow",
                attrs: { "aria-label": _vm.$t("Attachments.Title") }
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("Attachment.Attachment")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("Attachment.Downloaded")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("Attachment.DownloadOrRemove")))
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(
                    _vm.report.orgYearlyReportAttachments.attachmentsCollection
                      .attachments,
                    function(attachment, index) {
                      return _c(
                        "tr",
                        { key: index },
                        [
                          _c(
                            "th",
                            { staticClass: "row-heading" },
                            [
                              _c("plain-text-control", {
                                attrs: {
                                  title: attachment.displayKey,
                                  required: attachment.isRequired,
                                  noMargin: true
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              class: {
                                normal: true,
                                "validation-error":
                                  !_vm.uploading.includes(index) &&
                                  _vm.isFileNameDuplicate(
                                    attachment.fileNameWithExtension
                                  )
                              }
                            },
                            [
                              _vm.uploading.includes(index)
                                ? _c("span", [
                                    _c("i", [
                                      _vm._v(
                                        _vm._s(_vm.$t("Attachment.Downloading"))
                                      )
                                    ])
                                  ])
                                : _c("span", [
                                    attachment.fileNameWithExtension
                                      ? _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              attachment.fileNameWithExtension
                                            )
                                          )
                                        ])
                                      : _c("i", [
                                          _vm._v(
                                            _vm._s(_vm.$t("Attachment.NoFile"))
                                          )
                                        ])
                                  ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("attachment-wrapper-table-cell", {
                            key: "attachment-" + index,
                            attrs: {
                              inputId: "attachment" + index,
                              required: attachment.isRequired,
                              attachment: attachment
                            },
                            on: {
                              "start-upload": function($event) {
                                return _vm.startUpload($event, index)
                              },
                              "stop-upload": function($event) {
                                return _vm.stopUpload($event, index)
                              },
                              "deleted-attachment": function($event) {
                                return _vm.deletedAttachment($event, attachment)
                              },
                              "added-attachment": function($event) {
                                return _vm.addedAttachment($event, attachment)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }
                  ),
                  0
                )
              ]
            ),
            _vm._v(" "),
            _c("radio-button-row", {
              attrs: {
                title: "Attachments.AupNeeded",
                instructionsKey: "Attachments.AupNeeded_Instructions",
                required: true
              },
              model: {
                value: _vm.report.orgYearlyReportAttachments.aupNeeded,
                callback: function($$v) {
                  _vm.$set(
                    _vm.report.orgYearlyReportAttachments,
                    "aupNeeded",
                    $$v
                  )
                },
                expression: "report.orgYearlyReportAttachments.aupNeeded"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }